import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { CommitmentCriteriaFormGroup } from '@core/models/contract-commitment-criteria.model';

@Component({
standalone: false,
  selector: 'criteria-commitment-date-group',
  templateUrl: './criteria-commitment-date-group.component.html',
  styleUrls: ['../criteria-group.component.scss'],
})
export class CriteriaCommitmentDateGroupComponent {
  @Input() group: CommitmentCriteriaFormGroup;
  @Input() isPastYearContract: boolean;

  groupForm: FormGroup;
  groupPrefix: string = 'criteria_';

  constructor(private fb: FormBuilder) {
    this.groupForm = this.fb.group({});
  }
}
